var map = {
	"./AssemblyPoint/legend.png": 905,
	"./Callpoint/legend.png": 906,
	"./ControlPanel/legend.png": 907,
	"./EmergencyLighting-HQ/legend.png": 908,
	"./Evacuation-Bed/legend.png": 909,
	"./Evacuation-Chair/legend.png": 910,
	"./Exit-Right/legend.png": 911,
	"./Exit-Stairs-Up/legend.png": 912,
	"./Exit-Up/legend.png": 913,
	"./Exit/legend.png": 914,
	"./Fire-Alarm/legend.png": 915,
	"./Fire-Door-FD30/legend.png": 916,
	"./Fire-Door-FD60/legend.png": 917,
	"./Fire-Door/legend.png": 918,
	"./Fire-Extinguisher-Dry-Powder/legend.png": 919,
	"./Fire-Extinguisher-Foam/legend.png": 920,
	"./Fire-Extinguisher-Water-Mist/legend.png": 921,
	"./Fire-Extinguisher-Water/legend.png": 922,
	"./Fire-Extinguisher-Wet-Chemical/legend.png": 923,
	"./Fire-Extinguisher/legend.png": 924,
	"./Fire-Hose/legend.png": 925,
	"./Fire-Ladder/legend.png": 926,
	"./Fire-Suppression-System/legend.png": 927,
	"./First-Aid-Green/legend.png": 928,
	"./First-Aid-Red/legend.png": 929,
	"./Lift-Symbol/legend.png": 930,
	"./Location-Green/legend.png": 931,
	"./Location-Red/legend.png": 932,
	"./Phone-Green/legend.png": 933,
	"./Phone-Red/legend.png": 934,
	"./Running-Man-Door-Symbol-Left/legend.png": 935,
	"./Running-Man-Door-Symbol-Right/legend.png": 936,
	"./Running-Man-Symbol/legend.png": 937,
	"./Site-Evacuator/legend.png": 938,
	"./Smoke-Detector-V1/legend.png": 939,
	"./Smoke-Detector-V2/legend.png": 940,
	"./Sprinkler-System/legend.png": 941,
	"./designated-smoking-area/legend.png": 942,
	"./direction-diagonal-bottom-left/legend.png": 943,
	"./direction-diagonal-bottom-right/legend.png": 944,
	"./direction-diagonal-top-left/legend.png": 945,
	"./direction-diagonal-top-right/legend.png": 946,
	"./direction-down/legend.png": 947,
	"./direction-left/legend.png": 948,
	"./direction-right/legend.png": 949,
	"./exit-down/legend.png": 950,
	"./exit-left/legend.png": 951,
	"./exit-stairs-down/legend.png": 952,
	"./fire-blanket/legend.png": 953,
	"./fire-exit-left/legend.png": 954,
	"./fire-exit-right/legend.png": 955,
	"./fire-extinguisher-CO2/legend.png": 956,
	"./no-smoking/legend.png": 957,
	"./warning/legend.png": 958,
	"./youAreHere/legend.png": 959
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 158;